import styled from "styled-components";

export const Styles = styled.div`
  scroll-margin-top: 20px;
  padding: 0 130px 100px;
  direction: rtl;

  @media screen and (max-width: 992px) {
    padding: 0 40px 80px;
  }

  @media screen and (max-width: 600px) {
    padding: 0 20px 70px;
  }

  .request-section {
    display: grid;
    grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
    gap: 60px;
    align-items: center;
    padding: 55px 60px;
    background: #f5f6f7;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;

    @media screen and (max-width: 900px) {
      grid-template-columns: 1fr;
      gap: 35px;
      padding: 40px;
    }

    @media screen and (max-width: 600px) {
      padding: 30px 20px;
    }
  }

  .request-intro {
    .request-label {
      display: block;
      margin-bottom: 18px;
      color: #1a1a1c;
      font-family: IRANSans;
      font-size: 16px;
      font-weight: 500;
    }

    h2 {
      margin: 0 0 18px;
      color: #1a1a1c;
      font-family: IRANSans;
      font-size: 34px;
      line-height: 1.4;
      font-weight: 600;

      @media screen and (max-width: 600px) {
        font-size: 27px;
      }
    }

    p {
      margin: 0;
      color: #5b616e;
      font-family: IRANSans;
      font-size: 17px;
      line-height: 2;
    }
  }

  .request-form {
    padding: 30px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);

    @media screen and (max-width: 600px) {
      padding: 22px 16px;
    }
  }

  .form-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
      gap: 0;
    }
  }

  .field {
    margin-bottom: 20px;

    label {
      display: block;
      margin-bottom: 9px;
      color: #1a1a1c;
      font-family: IRANSans;
      font-size: 15px;
      font-weight: 500;
    }

    input,
    textarea {
      box-sizing: border-box;
      width: 100%;
      padding: 14px 16px;
      color: #1a1a1c;
      background: #f5f6f7;
      border: 1px solid #e5e7ea;
      border-radius: 8px;
      outline: none;
      font-family: IRANSans;
      font-size: 16px;
      transition: border-color 0.2s, background 0.2s;

      &:focus {
        background: #ffffff;
        border-color: #2f70b5;
      }

      &.invalid {
        border-color: #db5940;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.7;
      }
    }

    textarea {
      resize: vertical;
      min-height: 130px;
      line-height: 1.8;
    }

    .field-error {
      display: block;
      margin-top: 7px;
      color: #c62828;
      font-family: IRANSans;
      font-size: 13px;
    }
  }

  .form-footer {
    display: flex;
    align-items: center;
    gap: 18px;

    @media screen and (max-width: 600px) {
      align-items: stretch;
      flex-direction: column;
    }

    button {
      min-width: 145px;
      padding: 15px 25px;
      color: #ffffff;
      background: #1a1a1c;
      border: 1px solid #1a1a1c;
      border-radius: 8px;
      cursor: pointer;
      font-family: IRANSans;
      font-size: 16px;
      transition: color 0.2s, background 0.2s;

      &:hover:not(:disabled) {
        color: #1a1a1c;
        background: #ffffff;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
      }
    }

    .submit-message {
      font-family: IRANSans;
      font-size: 14px;
      line-height: 1.7;

      &.success {
        color: #2e7d32;
      }

      &.error {
        color: #c62828;
      }
    }
  }
`;
